export const LEGGI = [
    {
        "tipo": "Legge costituzionale",
        "titolo": "Proroga del termine di otto mesi previsto dall'art. 4 del decreto legislativo 16 marzo 1946, n. 98, per la durata dell'Assemblea Costituente",
        "riferimento": "Legge costituzionale 21 febbraio 1947, n. 1. G.U. n. 44 del 22 febbraio 1947."
    },
    {
        "tipo": "Legge costituzionale",
        "titolo": "Proroga del termine previsto dall'art. 4 del decreto legislativo 16 marzo 1946, n. 98, per la durata dell'Assemblea Costituente",
        "riferimento": "Legge costituzionale 17 giugno 1947, n. 2. G.U. n. 137 del 19 giugno 1947."
    },
    {
        "tipo": "Legge costituzionale",
        "titolo": "Soppressione del Senato e determinazione della posizione giuridica dei suoi componenti",
        "riferimento": "Legge costituzionale 3 novembre 1947, n. 3. G.U. n. 256 del 7 novembre 1947."
    },
    {
        "tipo": "Legge costituzionale",
        "titolo": "Norme sui giudizi di legittimità costituzionale e sulle garanzie di indipendenza della Corte Costituzionale",
        "riferimento": "Legge costituzionale 9 febbraio 1948, n. 1. G.U. n. 43 del 20 febbraio 1948."
    },
    {
        "tipo": "Legge costituzionale",
        "titolo": "Conversione in legge costituzionale dello Statuto della Regione siciliana, approvato col decreto legislativo 15 maggio 1946, n.455",
        "riferimento": "Legge costituzionale 26 febbraio 1948, n. 2. G.U. n. 58 del 9 marzo 1948."
    },
    {
        "tipo": "Legge costituzionale",
        "titolo": "Statuto speciale per la Sardegna",
        "riferimento": "Legge costituzionale 26 febbraio 1948, n. 3. G.U. n. 58 del 9 marzo 1948."
    },
    {
        "tipo": "Legge costituzionale",
        "titolo": "Statuto speciale per la Valle d'Aosta",
        "riferimento": "Legge costituzionale 26 febbraio 1948, n. 4. G.U. n. 59 del 10 marzo 1948."
    },
    {
        "tipo": "Legge costituzionale",
        "titolo": "Statuto speciale per il Trentino-Alto Adige",
        "riferimento": "Legge costituzionale 26 febbraio 1948, n. 5. G.U. n. 62 del 13 marzo 1948."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Modificazione delle formule di giuramento",
        "riferimento": "Legge 23 dicembre 1946, n. 478. G.U. n. 3 del 4 gennaio 1947."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Partecipazione dell'Italia agli Accordi sulla costituzione del Fondo monetario internazionale e della Banca internazionale per la ricostruzione e lo sviluppo",
        "riferimento": "Legge 23 marzo 1947, n. 132. G.U. n. 71 del 27 marzo 1947, S.O."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Modifiche al testo unico della legge comunale e provinciale approvato con Regio decreto 3 marzo 1934, n.383, e successive modificazioni",
        "riferimento": "Legge 28 marzo 1947, n. 530. G.U. n. 146 del 30 giugno 1947."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Ordinamento dell'industria cinematografica nazionale",
        "riferimento": "Legge 16 maggio 1947, n. 379. G.U. n. 122 del 30 maggio 1947."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Approvazione dell'Accordo tra il Governo italiano ed il Governo egiziano circa il risarcimento dei danni subiti dall'Egitto per effetto delle operazioni militari svoltesi nel suo territorio ed il dissequestro dei beni italiani in Egitto",
        "riferimento": "Legge 16 maggio 1947, n. 512. G.U. n. 144 del 27 giugno 1947."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Approvazione dell'Accordo internazionale per la costituzione della Organizzazione delle Nazioni Unite per l'alimentazione e l'agricoltura, concluso a Quebec il 16 ottobre 1945",
        "riferimento": "Legge 16 maggio 1947, n. 546. G.U. n. 147 del 1° luglio 1947."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Autorizzazione al Governo della Repubblica a ratificare il Trattato di Pace fra le Potenze Alleate e Associate e l'Italia",
        "riferimento": "Legge 2 agosto 1947, n. 811. G.U. n. 200 del 2 settembre 1947."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Convalida, con modificazioni ed aggiunte, del decreto legislativo del Capo provvisorio dello Stato 29 marzo 1947, n. 143, concernente l'istituzione di una imposta straordinaria progressiva sul patrimonio",
        "riferimento": "Legge 1° settembre 1947, n. 828. G.U. n. 202 del 4 settembre 1947, S.O."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Approvazione degli Accordi commerciali e di pagamento stipulati in Roma, tra l'Italia e la Svezia, il 24 novembre 1945",
        "riferimento": "Legge 29 settembre 1947, n. 1655. G.U. n. 40 del 17 febbraio 1948."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Norme per la disciplina dell'elettorato attivo e per la tenuta e la revisione annuale delle liste elettorali",
        "riferimento": "Legge 7 ottobre 1947, n. 1058. G.U. n. 235 del 13 ottobre 1947, S.O."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Modificazioni al Codice penale per la parte riguardante i delitti contro le istituzioni costituzionali dello Stato",
        "riferimento": "Legge 11 novembre 1947, n. 1317. G.U. n. 278 del 3 dicembre 1947."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Approvazione dello scambio di Note effettuato in Roma fra l'Italia e la Francia, circa il recupero di navi mercantili francesi affondate nelle acque territoriali italiane",
        "riferimento": "Legge 13 novembre 1947, n. 1422. G.U. n. 294 del 23 dicembre 1947."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Approvazione dell'Accordo fra l'Italia e l'Argentina in materia di emigrazione, concluso a Roma il 21 febbraio 1947",
        "riferimento": "Legge 13 novembre 1947, n. 1452. G.U. n. 301 del 31 dicembre 1947."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Approvazione dell'Atto di emendamento della Costituzione dell'Organizzazione Internazionale del Lavoro e della Convenzione per la revisione parziale delle Convenzioni adottate dalla Conferenza Generale dell'Organizzazione Internazionale del Lavoro nelle sue prime 28 sessioni, per assicurare l'esercizio futuro di alcune funzioni di cancelleria affidate dalle predette Convenzioni al Segretario generale della Società delle Nazioni e per apportarvi emendamenti complementari resisi necessari in seguito alla estinzione della Società delle Nazioni ed all'emendamento della Costituzione dell'Organizzazione del Lavoro",
        "riferimento": "Legge 13 novembre 1947, n. 1622. G.U. n. 27 del 3 febbraio 1948, S.O."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Revoca dall'impegno per mancata fede al giuramento",
        "riferimento": "Legge 16 novembre 1947, n. 1318. G.U. n. 278 del 3 dicembre 1947."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Approvazione del Trattato di pace e relativo scambio di Note fra la Repubblica italiana e la Repubblica di Cuba, firmato all'Avana il 30 giugno 1947",
        "riferimento": "Legge 27 novembre 1947, n. 1442. G.U. n. 300 del 30 dicembre 1947."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Approvazione del Trattato di amicizia e relazioni generali fra la Repubblica Italiana e la Repubblica delle Filippine, firmato a Roma il 9 luglio 1947",
        "riferimento": "Legge 27 novembre 1947, n. 1491. G.U. n. 6 del 9 gennaio 1948."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Norme per la repressione dell'attività fascista e dell'attività diretta alla restaurazione dell'istituto monarchico",
        "riferimento": "Legge 3 dicembre 1947, n. 1546. G.U. n. 13 del 17 gennaio 1948."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Norme per la compilazione delle liste elettorali nella provincia di Gorizia",
        "riferimento": "Legge 12 dicembre 1947, n. 1379. G.U. n. 287 del 15 dicembre 1947."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Approvazione dello scambio di Note relativo ai danni di guerra ed all'art.79 del Trattato di Pace, effettuato in Roma il 30 luglio 1947 fra l'Italia e la Cina",
        "riferimento": "Legge 16 dicembre 1947, n. 1443. G.U. n. 300 del 30 dicembre 1947."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Approvazione dell'Accordo concluso a Roma tra l'Italia e la Svezia il 19 aprile 1947, relativo all'emigrazione di operai italiani in Svezia",
        "riferimento": "Legge 16 dicembre 1947, n. 1621. G.U. n. 27 del 3 febbraio 1948."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Approvazione degli Atti internazionali conclusi a Neuchâtel, tra l'Italia ed altri Stati, l'8 febbraio 1947 per la conservazione o la reintegrazione dei diritti di proprietà industriale colpiti dalla seconda guerra mondiale",
        "riferimento": "Legge 16 dicembre 1947, n. 1623. G.U. n. 28 del 4 febbraio 1948."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Approvazione degli Accordi di carattere economico conclusi ad Ankara, tra l'Italia e la Turchia, il 12 aprile 1947",
        "riferimento": "Legge 16 dicembre 1947, n. 1657. G.U. n. 41 del 18 febbraio 1948."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Approvazione degli Accordi e scambio di Note tra l'Italia e il Belgio effettuate a Roma",
        "riferimento": "Legge 16 dicembre 1947, n. 1663. G.U. n. 42 del 19 febbraio 1948."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Approvazione degli Accordi di carattere economico, conclusi in Roma, tra l'Italia ed i Paesi Bassi, il 30 agosto 1946",
        "riferimento": "Legge 16 dicembre 1947, n. 1672. G.U. n. 44 del 21 febbraio 1948."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Approvazione del Protocollo di emendamento agli Accordi, Convenzioni e Protocolli sugli stupefacenti e dell'annesso al Protocollo stesso",
        "riferimento": "Legge 16 dicembre 1947, n. 1674. G.U. n. 45 del 23 febbraio 1948."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Approvazione degli Accordi di carattere economico, conclusi in Roma, tra l'Italia e l'Ungheria, il 9 novembre 1946",
        "riferimento": "Legge 16 dicembre 1947, n. 1682. G.U. n. 46 del 24 febbraio 1948."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Approvazione degli Accordi di carattere economico, conclusi in Roma, tra l'Italia e la Danimarca, il 2 marzo 1946",
        "riferimento": "Legge 16 dicembre 1947, n. 1728. G.U. n. 54 del 4 marzo 1948."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Approvazione degli Accordi di carattere economico conclusi in Roma, tra l'Italia e la Francia, il 22 dicembre 1946",
        "riferimento": "Legge 16 dicembre 1947, n. 1757. G.U. n. 66 del 18 marzo 1948."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Approvazione degli Accordi commerciali e di pagamento conclusi in Roma, tra l'Italia ed il Belgio, il 18 aprile 1946",
        "riferimento": "Legge 16 dicembre 1947, n. 1763. G.U. n. 74 del 29 marzo 1948, S.O."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Norme per la limitazione temporanea del diritto di voto ai capi responsabili del regime fascista",
        "riferimento": "Legge 23 dicembre 1947, n. 1453. G.U. n. 301 del 31 dicembre 1947."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Riordinamento dei Corpi consultivi del Ministero della pubblica istruzione",
        "riferimento": "Legge 30 dicembre 1947, n. 1477. G.U. n. 3 del 5 gennaio 1948."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Norme per la istituzione dell'Opera di valorizzazione della Sila",
        "riferimento": "Legge 31 dicembre 1947, n. 1629. G.U. n. 30 del 6 febbraio 1948."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Norme per l'elezione della Camera dei Deputati",
        "riferimento": "Legge 20 gennaio 1948, n. 6. G.U. n. 20 del 26 gennaio 1948, S.O."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Modificazioni alla legge 7 ottobre 1947, n.1058, per la prima elezione della Camera dei Deputati e del Senato della Repubblica",
        "riferimento": "Legge 4 febbraio 1948, n. 24. G.U. n. 29 del 5 febbraio 1948, S.O."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Norme per la formazione delle liste elettorali nella provincia di Bolzano",
        "riferimento": "Legge 4 febbraio 1948, n. 25. G.U. n. 29 del 5 febbraio 1948, S.O."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Norme per la elezione del Senato della Repubblica",
        "riferimento": "Legge 6 febbraio 1948, n. 29. G.U. n. 31 del 7 febbraio 1948, S.O."
    },
    {
        "tipo": "Legge ordinaria",
        "titolo": "Disposizioni sulla stampa",
        "riferimento": "Legge 8 febbraio 1948, n. 47. G.U. n. 43 del 20 febbraio 1948."
    }
]